import { render, staticRenderFns } from "./FunnelCreateUpdate.vue?vue&type=template&id=528c5b2b&scoped=true&"
import script from "./FunnelCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./FunnelCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./FunnelCreateUpdate.vue?vue&type=style&index=0&id=528c5b2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528c5b2b",
  null
  
)

export default component.exports